export enum actionTypes {
    PRINT = 'print',
    MAIL = 'mail',
    QUICK_MAIL = 'quickMail',
    SHOW = 'show'
}

export const mapActionToMode = {
    [actionTypes.PRINT]: 1,
    [actionTypes.SHOW]: 2,
    [actionTypes.MAIL]: 3,
    [actionTypes.QUICK_MAIL]: 5
};

export const mapModeToAction = {
    '1': actionTypes.PRINT,
    '2': actionTypes.SHOW,
    '3': actionTypes.MAIL,
    '5': actionTypes.QUICK_MAIL
};
export const actionTypeProps = isPluginDisabled => ({
    [actionTypes.PRINT]: {
        isQuickPrintEnabled: !isPluginDisabled,
        isAttachmentEnabled: !isPluginDisabled,
        isPdfEnabled: false
    },
    [actionTypes.SHOW]: {
        isQuickPrintEnabled: false,
        isAttachmentEnabled: false,
        isPdfEnabled: true
    },
    [actionTypes.MAIL]: {isQuickPrintEnabled: false, isAttachmentEnabled: true, isPdfEnabled: true},
    [actionTypes.QUICK_MAIL]: {
        isQuickPrintEnabled: false,
        isAttachmentEnabled: true,
        isPdfEnabled: true
    }
});
